module.exports = __webpack_public_path__ + "img/d3-active.ef3858f0.png";